import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-list-group-item q-list-group-item q-d-flex q-justify-content-between q-align-items-start q-px-0 q-p-1 q-text-start" }
const _hoisted_2 = ["innerHTML"]

import { computed, inject } from 'vue'
import { useUrlStore } from '@/store/SerpPage/UrlStore'
import { useSearchQueryStore } from '@/store/SearchQueryStore'
import { storeToRefs } from 'pinia'
import { useMobileViewStore } from '@/store/MobileViewStore'
import { highlightText } from '@/core/highlight'
import type { AggregationSuggestionItem as AggregationSuggestionItemType } from '@/store/AutocompletePopup/AutocompleteAggregationsStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'AggregationSuggestionItem',
  props: {
    field: {},
    item: {}
  },
  setup(__props: any) {

const props = __props

const SmartSearchConfig = inject('SmartSearchConfig')?.value as { appConfiguration: { redirectionUrl: string } } | undefined

const urlStore = useUrlStore()
const searchQueryStore = useSearchQueryStore()
const { searchQuery } = storeToRefs(searchQueryStore)

const mobileViewStore = useMobileViewStore()
const { isMobileView } = storeToRefs(mobileViewStore)

const redirectionUrl = computed(() => SmartSearchConfig?.appConfiguration?.redirectionUrl ?? '/search')

const highlightedLabel = computed(() => highlightText(
  props.item.displayLabel,
  searchQuery.value ?? '',
  'aggregation-suggestion__highlight'
))

function applyFilter() {
  const params = new URLSearchParams()
  const query = searchQueryStore.searchQuery
  if (query) {
    params.set('q', query)
  }

  params.set(`f[${props.field}]`, JSON.stringify([props.item.value]))

  const targetPath = buildTargetPath(params)
  urlStore.goToSerpPage(targetPath, query ?? '')
}

function buildTargetPath(params: URLSearchParams): string {
  const base = redirectionUrl.value || '/'
  const queryString = params.toString()
  if (!queryString) {
    return base
  }

  const separator = base.includes('?') ? '&' : '?'
  return `${base}${separator}${queryString}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["aggregation-suggestion__link q-text-decoration-none q-link-secondary", {'q-btn q-btn-danger q-rounded-3 q-shadow-sm q-me-2': _unref(isMobileView)}]),
      onClick: applyFilter
    }, [
      _createElementVNode("span", {
        class: "aggregation-suggestion__label",
        innerHTML: highlightedLabel.value
      }, null, 8, _hoisted_2)
    ], 2)
  ]))
}
}

})